import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
    return (
        <>
            <footer className="site-footer">
                <div className="container">
                    <div className="site-footer__top">
                        <div className="row aligncenter">
                            <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms" >
                                <div className="footer-widget__column footer-widget__about">
                                    <div className="main-header__top-address">
                                        <Link to="/" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}><img src="/assets/images/resources/Logo-VyL-Asociados-Blanco.png" alt=""
                                            className='footerLogo' /></Link>
                                        <p style={{ color: 'white', textAlign: 'justify' }}>
                                            Somos una empresa especializada en la
                                            externalización de servicios generales.
                                            Nuestro compromiso con la calidad en el
                                            trabajo y nuestros trabajadores nos
                                            convierte en el mejor aliado empresarial.
                                        </p>
                                        <a href="https://www.vyl-asociados.com" target="_blank" style={{ color: 'white', display: 'block', textAlign: 'left', marginTop: '20px', fontWeight: 'bold' }}>www.vyl-asociados.com</a>

                                    </div>

                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms" style={{ paddingTop: '80px' }}>
                                <div className="footer-widget__column footer-widget__explore clearfix">
                                    <h3 className="footer-widget__title">Menú</h3>
                                    <ul className="footer-widget__explore-list list-unstyled clearfix">
                                        <li>
                                            <Link to="/" style={{ textDecoration: 'none', color: 'inherit', fontFamily: 'Axiforma-Bold, sans-serif' }}>
                                                Inicio
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/about" style={{ textDecoration: 'none', color: 'inherit', fontFamily: 'Axiforma-Bold, sans-serif' }}>
                                                Nosotros
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/solutions" style={{ textDecoration: 'none', color: 'inherit', fontFamily: 'Axiforma-Bold, sans-serif' }}>
                                                Soluciones
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms" style={{ paddingTop: '80px' }}>
                                <div className="footer-widget__column footer-widget__explore clearfix">
                                    <h3 className="footer-widget__title">Contáctanos</h3>
                                    <ul className="footer-widget__explore-list list-unstyled clearfix">
                                        <li> <span style={{ fontFamily: 'Axiforma-Bold' }}>Teléfono</span></li>
                                        <li>
                                            <div className="text">
                                                <p><a href="tel:+51915249836" style={{ fontFamily: 'Axiforma-Regular', fontWeight: 400 }}>+51 915249836</a></p>
                                            </div>
                                        </li>
                                        <li>
                                            <span style={{ fontFamily: 'Axiforma-Bold' }}>Correo</span>
                                        </li>
                                        <li>
                                            <div className="text">
                                                <p><a href="mailto:fatima.giron@vyl-asociados.com" style={{ fontFamily: 'Axiforma-Regular', fontWeight: 400 }}>fatima.giron@vyl-asociados.com</a></p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>



                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms" style={{ paddingTop: '80px' }}>
                                <div className="footer-widget__column footer-widget__newsletter clearfix">
                                    <h3 className="footer-widget__title">Oficina</h3>
                                    <ul className="footer-widget__explore-list list-unstyled clearfix">
                                        <li> <span style={{ fontFamily: 'Axiforma-Bold' }}>Talara</span></li>
                                        <li> Urb. Los Vencedores A-19</li>
                                        <li> Segunda Etapa - Talara</li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </footer>
        </>
    );
};

export default Footer;